import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "恋爱", to: "/category/love" },
  { label: "校园", to: "/category/campus" },
  { label: "都市", to: "/category/city" },
  { label: "甜宠", to: "/category/sweet" },
  { label: "完结", to: "/category/complete" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (q) {
      navigate(`/category/all?q=${encodeURIComponent(q)}`);
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md shadow-soft border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="container-site flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex shrink-0 items-center gap-2 cursor-pointer" aria-label="89890漫画网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" aria-hidden="true" />
          </span>
          <span className={`font-heading text-lg font-bold leading-none md:text-xl ${solid ? "text-foreground-950" : "text-white"}`}>
            89890<span className="text-primary-500">漫画网</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? "text-primary-600"
                    : solid
                      ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                      : "text-white/90 hover:text-white hover:bg-white/10"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={handleSearch}
            className={`hidden md:flex items-center overflow-hidden rounded-full border transition-colors ${
              solid ? "border-background-300/70 bg-background-100" : "border-white/30 bg-white/10"
            }`}
            role="search"
          >
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画名称…"
              aria-label="搜索漫画"
              className={`w-40 bg-transparent px-4 py-2 text-sm outline-none placeholder:text-foreground-500 ${
                solid ? "text-foreground-950" : "text-white placeholder:text-white/60"
              }`}
            />
            <button
              type="submit"
              aria-label="搜索"
              className={`flex h-9 w-9 items-center justify-center rounded-full text-base cursor-pointer ${
                solid ? "text-foreground-700 hover:text-primary-600" : "text-white/90 hover:text-white"
              }`}
            >
              <i className="ri-search-line" aria-hidden="true" />
            </button>
          </form>

          <Link
            to="/category/love"
            className="btn-primary hidden md:inline-flex !py-2 text-sm"
          >
            立即阅读
          </Link>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-md text-xl lg:hidden cursor-pointer ${
              solid ? "text-foreground-900" : "text-white"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <div className="container-site flex flex-col gap-1 py-3">
            <form onSubmit={handleSearch} className="mb-2 flex items-center overflow-hidden rounded-full border border-background-300/70 bg-background-100 md:hidden">
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名称…"
                aria-label="搜索漫画"
                className="w-full bg-transparent px-4 py-2 text-sm outline-none text-foreground-950 placeholder:text-foreground-500"
              />
              <button type="submit" aria-label="搜索" className="flex h-9 w-9 shrink-0 items-center justify-center text-foreground-700 cursor-pointer">
                <i className="ri-search-line" aria-hidden="true" />
              </button>
            </form>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium cursor-pointer ${
                    isActive ? "bg-primary-50 text-primary-600" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}